import { ApolloError, useMutation } from '@apollo/client'

import { Form, FormSubmitInput, MutationSubmitFormArgs } from '@types'

import { MUTATION_SUBMIT_FORM } from '@libs/apollo/mutations/form.mutation'

interface Data {
  submitForm?: Form
}

interface useSubmitFormProps {
  onCompleted?: () => void
}

export const useSubmitForm = (
  props?: useSubmitFormProps,
): {
  submitForm: (input: FormSubmitInput) => void
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [submitForm, { loading: loadingSubmit, error, data }] = useMutation<Data, MutationSubmitFormArgs>(
    MUTATION_SUBMIT_FORM,
    {
      notifyOnNetworkStatusChange: true,
    },
  )

  const _submitForm = async (input: FormSubmitInput) => {
    submitForm({
      variables: { input },
      onCompleted: props?.onCompleted,
      update: (cache, { data }) => {
        cache.modify({
          id: cache.identify({ __typename: 'Form', id: input.formId }),
          fields: {
            formModel: () => data?.submitForm?.formModel,
          },
        })
      },
    })
  }

  return { submitForm: _submitForm, loading: loadingSubmit, error, data }
}
